// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__3Y-Dg","Label":"Checkbox_Label__1sfix","InputElement":"Checkbox_InputElement__2C9BR","Invalid":"Checkbox_Invalid__3clHF"};